import { VDBText } from "@components/atoms";
import { SpaceType } from "@components/atoms/Spacer/types";
import { useTypographyStore } from "@redux/slices/typographySlice";
import styled from "styled-components/native";
import { useTheme } from "styled-components/native";
import { RectangularTextViewWithDetailProps } from "./types";
import { useState } from "react";
import { css } from "styled-components/native";
import currency from "currency.js";
import { useUserInfo } from "@redux/slices/userInfoSlice";
import { DefaultTheme } from "styled-components/native";

const RectangularTextViewWithDetail = ({
  backgroundColor,
  borderColor,
  isSelected,
  item,
  numberOfLines = 0,
  onPress,
}: RectangularTextViewWithDetailProps) => {
  const theme = useTheme();
  const typography = useTypographyStore();
  const [isHovered, setIsHovered] = useState(false);
  const isUnavailable = false;
  const userInfo = useUserInfo();

  return (
    <Container
      backgroundColor={backgroundColor}
      borderColor={borderColor}
      onHoverIn={() => {
        if (theme.isLargeScreen) {
          setIsHovered(true);
        }
      }}
      onHoverOut={() => {
        if (theme.isLargeScreen) {
          setIsHovered(false);
        }
      }}
      isHovered={isHovered}
      isUnavailable={isUnavailable}
      onPress={() => {
        onPress(item);
      }}
    >
      <TextContainer>
        <VDBText
          color={
            theme[
              isSelected ? "core-05" : isUnavailable ? "core-04" : "option-cont"
            ]
          }
          type={typography["Body-M"]}
          textAlign={"center"}
          numberOfLines={numberOfLines}
        >
          {item?.label}
        </VDBText>
      </TextContainer>
      <TextContainer>
        <VDBText
          color={
            theme[
              isSelected ? "core-05" : isUnavailable ? "core-04" : "option-cont"
            ]
          }
          type={typography["Body-M"]}
          textAlign={"center"}
          numberOfLines={numberOfLines}
        >
          {item?.price && item?.price > 0
            ? currency(item?.price, {
                symbol: userInfo.user?.currency_symbol,
                precision: 0,
              }).format()
            : "-"}
        </VDBText>
      </TextContainer>
    </Container>
  );
};

const Container = styled.Pressable<{
  backgroundColor: string;
  borderColor: string;
  isHovered: boolean;
  isUnavailable?: boolean;
}>`
  height: 52px;
  background-color: ${({
    backgroundColor,
    isHovered,
    theme,
    isUnavailable,
  }: {
    backgroundColor: string;
    isHovered: boolean;
    theme: DefaultTheme;
    isUnavailable: boolean;
  }) =>
    isHovered
      ? theme["option-bg-static"]
      : isUnavailable
      ? theme["core-02"]
      : backgroundColor};
  border-color: ${({
    borderColor,
    theme,
    isHovered,
    isUnavailable,
  }: {
    borderColor: string;
    theme: DefaultTheme;
    isHovered: boolean;
    isUnavailable: boolean;
  }) => (isHovered || isUnavailable ? theme["core-04"] : borderColor)};
  border-width: 1px;
  align-items: center;
  justify-content: center;
  border-radius: ${SpaceType.Basic}px;
  vertical-padding: 6px;
  ${({ isUnavailable }: { isUnavailable: boolean }) =>
    isUnavailable &&
    css`
      border-style: dashed;
    `};
`;

const TextContainer = styled.View`
  padding-left: 8px;
  padding-right: 8px;
  align-items: center;
  justify-content: center;
  height: 20px;
  max-width: ${({ theme }: { theme: DefaultTheme }) =>
    theme.isMobile ? 311 : 408}px;
`;

export default RectangularTextViewWithDetail;
